var _path, _path2, _circle, _circle2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMastercardLogoWhite = function SvgMastercardLogoWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 24,
    "aria-label": "master",
    viewBox: "0 0 38 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3",
    opacity: 0.07
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 12,
    r: 7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 12,
    r: 7,
    fill: "#A7A7A7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#484848",
    d: "M22 12c0-2.4-1.2-4.5-3-5.7-1.8 1.3-3 3.4-3 5.7s1.2 4.5 3 5.7c1.8-1.2 3-3.3 3-5.7"
  })));
};
export { SvgMastercardLogoWhite as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzOCAyNCIgcm9sZT0iaW1nIiB3aWR0aD0iMzgiIGhlaWdodD0iMjQiIGFyaWEtbGFiZWw9Im1hc3RlciI+PHRpdGxlIGlkPSJwaS1tYXN0ZXIiPk1hc3RlcmNhcmQ8L3RpdGxlPjxwYXRoIG9wYWNpdHk9Ii4wNyIgZD0iTTM1IDBIM0MxLjMgMCAwIDEuMyAwIDN2MThjMCAxLjcgMS40IDMgMyAzaDMyYzEuNyAwIDMtMS4zIDMtM1YzYzAtMS43LTEuNC0zLTMtM3oiLz48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMzUgMWMxLjEgMCAyIC45IDIgMnYxOGMwIDEuMS0uOSAyLTIgMkgzYy0xLjEgMC0yLS45LTItMlYzYzAtMS4xLjktMiAyLTJoMzIiLz48Y2lyY2xlIGZpbGw9IiMwMDAwMDAiIGN4PSIxNSIgY3k9IjEyIiByPSI3Ii8+PGNpcmNsZSBmaWxsPSIjQTdBN0E3IiBjeD0iMjMiIGN5PSIxMiIgcj0iNyIvPjxwYXRoIGZpbGw9IiM0ODQ4NDgiIGQ9Ik0yMiAxMmMwLTIuNC0xLjItNC41LTMtNS43LTEuOCAxLjMtMyAzLjQtMyA1LjdzMS4yIDQuNSAzIDUuN2MxLjgtMS4yIDMtMy4zIDMtNS43eiIvPjwvc3ZnPg==";